import React, {useState} from "react";
import {Button, Form} from "react-bootstrap";
import * as t from "counterpart";
import api from "../../../utilities/API";

function Coupon ({onChange, className})
{
    const [coupon, setCoupon] = useState({});

    //
    const checkCoupon = () =>
    {
        api("commerce/coupons/check/code", {
            method: "POST",
            data: {code: coupon.input},
            result: (data) => {
                setCoupon({...coupon, error: null, code: data.coupon_code, discount: data.discount, percent: data.percent});
                onChange(data);
            },
            error: (error) => {
                if(error === "Coupon not valid") {
                    error = t(error)
                }

                setCoupon({...coupon, error});
            }
        });
    };

    return (
        <div id="coupon" className={className}>
            <h3><span>٪</span> {t("Discount Code")}</h3>
            <div className="row" style={{alignItems: "flex-start"}}>
                <Form.Group controlId="coupon_code" className="col-sm-8">
                    <Form.Control name="coupon" placeholder={t("Discount Code")} value={coupon.input || ""} disabled={coupon.code} onChange={(e) => setCoupon({input: e.target.value})} />
                    <div className="error">{coupon.error}</div>
                    {coupon.code && <div className="success">
                        {t("discount")} {coupon.discount} {coupon.percent ? "%" : t(window.portalSetting("commerce.currency"))}
                    </div>}
                </Form.Group>
                {!coupon.code && <Button className="col-sm-4" onClick={checkCoupon}>{t("Add Code")}</Button>}
                {coupon.code &&  <Button className="col-sm-4" onClick={() => {
                    setCoupon({});
                    onChange(null);
                }} variant="danger">{t("Remove The Code")}</Button>}
            </div>
        </div>
    )
}

export default Coupon;
